import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormInputMaskDirective } from './form-input-mask.directive';

@NgModule({
  declarations: [FormInputMaskDirective],
  imports: [CommonModule],
  exports: [FormInputMaskDirective],
})
export class FormInputMaskModule {}
